import { createFileRoute } from '@tanstack/react-router'

import styles from './styles.module.scss'
import { useState } from 'react'

export const Route = createFileRoute('/desktop/__app/policies/')({
  component: RouteComponent,
})

function RouteComponent() {
  const [tab, setTab] = useState<'privacy' | 'responsability'>('privacy')

  return (
    <div className={styles.container}>
      <header>
        <h3>Políticas de uso</h3>

        <nav className={styles.header_pivot}>
          <button
            className={tab === "privacy" ? styles.active : ''}
            onClick={() => setTab('privacy')}
          >
            Política de privacidade
          </button>
          <button
            className={tab === "responsability" ? styles.active : ''}
            onClick={() => setTab('responsability')}
          >
            Jogo reponsável
          </button>
        </nav>
      </header>

      {
        tab === "privacy" && (
          <div dangerouslySetInnerHTML={{
            __html: `
 Política de Uso - Site <a href="https://sortelec.com.br/">sortelec.com.br</a>
<br ><br >
Bem-vindo à Política de Uso e Privacidade do site Sortelec Digital (sortelec.com.br), uma plataforma de loteria instantânea digital com dinâmica visual a sorteios, que realiza transações financeiras por meio de Pix. Esta política explica como coletamos, usamos e protegemos suas informações e os termos de uso do nosso site.
<br /><br />
1.⁠ ⁠Coleta de Informações
Ao utilizar o site <a href="https://sortelec.com.br/">sortelec.com.br</a>, podemos coletar as seguintes informações:
<br ><br >
Dados Pessoais: Nome completo, CPF, e-mail, número de telefone e dados bancários para transações via Pix.
Informações de Uso: Dados de navegação, dispositivo e IP para melhorar sua experiência.
Localização Aproximada: Podemos coletar sua localização geográfica para aprimorar nossos serviços e garantir maior segurança. Essa informação é recebida de forma anônima e não é vinculada diretamente aos seus dados pessoais. A coleta ocorre apenas se você autorizar o acesso à localização no seu navegador ou dispositivo.
<br /><br />
2.⁠ ⁠Transações via Pix
As transações são processadas exclusivamente via Pix.
O saque só será permitido se o nome do usuário estiver vinculado ao CPF informado durante o cadastro.
O valor mínimo para saque é de 10,00 R$.
Observação: prêmios maiores do que R$ 2.428,00 (dois mil quatrocentos e vinte e oito reais) serão pagos apenas na sede da Loteria Estadual do Ceará.
<br /><br />
3.⁠ ⁠Uso das Informações
Usamos suas informações para:
Processar transações de compra e saque via Pix.
Verificar sua identidade e prevenir fraudes.
Enviar comunicações sobre promoções, atualizações e suporte via e-mail.
<br /><br />
4.⁠ ⁠Segurança das Informações
Adotamos medidas de segurança para proteger seus dados contra acessos não autorizados, incluindo criptografia de dados e autenticação segura.
<br /><br />
5.⁠ ⁠Compartilhamento de Informações
Não compartilhamos suas informações com terceiros, exceto quando necessário para:
Processamento de transações via instituições financeiras.
Cumprimento de obrigações legais ou ordens judiciais.
<br /><br />
6.⁠ ⁠Direitos do Usuário
Você tem o direito, ao solicitar via e-mail sortelec@lotece.com.br, de:

Solicitar correção ou exclusão de seus dados pessoais.
Revogar o consentimento para o uso de seus dados a qualquer momento
 <br /><br />
7.⁠ ⁠Condições de Uso
Apenas usuários maiores de 18 anos podem utilizar a plataforma.
A compra de raspadinhas está restrita a usuários que estejam fisicamente localizados no estado do Ceará no momento da transação.
O cadastro no sistema está restrito a números de telefone com os DDDs 85 ou 88, correspondentes ao estado do Ceará.
É estritamente proibido criar ou utilizar múltiplas contas com a intenção de manipular resultados.
Não serão aceitos ou pagos prêmios nos casos em que forem comprovadas falhas no sistema ou indícios de fraude.
O Rasplec se reserva o direito de suspender ou encerrar contas que violem estas condições.
 <br /><br />
8.⁠ ⁠Alterações na Política
Podemos atualizar esta política a qualquer momento. As alterações entrarão em vigor imediatamente após sua publicação no site.
<br /><br />
9.⁠ ⁠Contato
Para dúvidas ou sugestões, entre em contato através do e-mail: sortelec@lotece.com.br ou pelo whatsapp 85 9848-0191.
`}}>

          </div>
        )
      }
      {
        tab === "responsability" && (
          <div
            dangerouslySetInnerHTML={{
              __html: ` 🎯 <b>Jogo Seguro</b> – <a href="sortelec.com.br">sortelec.com.br</a> <br /><br /> No sortelec.com.br, diversão e responsabilidade caminham juntas. Nosso Sortelec digital, foi desenvolvido para proporcionar entretenimento de forma simples, rápida e segura — sempre com total transparência nas regras e na distribuição dos prêmios.<br/>
💳 Pagamentos via Pix Todos os depósitos e saques são realizados exclusivamente via Pix, garantindo agilidade, praticidade e segurança nas transações.<br/>
🔒 Ambiente Seguro Utilizamos tecnologias de proteção de dados e protocolos de segurança para assegurar que suas informações e transações estejam protegidas.<br/>
 🎲 Jogue com Responsabilidade O Sortelec digital é uma forma de entretenimento. Recomendamos que você jogue com consciência, estabelecendo limites de tempo e valores.<br/>
Não utilize recursos destinados a despesas essenciais.
Não jogue sob influência de álcool ou outras substâncias.
Se sentir que está perdendo o controle, faça uma pausa.<br/>
 🚫 Proibido para menores de 18 anos A participação é permitida apenas para maiores de idade, conforme a legislação vigente.
Nosso compromisso é oferecer uma experiência divertida, transparente e responsável. Divirta-se no Sortelec.com.br — com segurança e moderação!`
            }}
          />

        )
      }
    </div>
  )
}
